export default __webpack_public_path__ + "static/media/people-flying.5bc31679.svg";